import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { useI18n } from "@/context/I18nContext";
import { PasswordField } from "@/components/ui/PasswordField";
import { TID } from "@/constants/testIds";

export default function Signup() {
  const { signup } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await signup(form.email, form.password, form.name); toast.success(t("accountCreated")); nav("/"); }
    catch (err) { toast.error(err?.response?.data?.detail || t("error")); }
    finally { setBusy(false); }
  };
  const input = "w-full px-4 py-3 rounded-2xl neu-inset focus:outline-none focus:ring-2 focus:ring-[#1e3a8a55]";
  return (
    <div className="neu-page min-h-screen flex items-center justify-center p-6">
      <form onSubmit={submit} className="w-full max-w-md neu p-8 space-y-5">
        <h2 className="font-display text-3xl font-bold neu-accent-blue">{t("signup")}</h2>
        <p className="text-sm text-slate-500">{t("tagline")}</p>
        <label className="block space-y-2"><span className="text-sm font-medium">{t("name")}</span>
          <input data-testid={TID.signupName} required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={input} />
        </label>
        <label className="block space-y-2"><span className="text-sm font-medium">{t("email")}</span>
          <input data-testid={TID.signupEmail} required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={input} />
        </label>
        <label className="block space-y-2"><span className="text-sm font-medium">{t("password")}</span>
          <PasswordField testId={TID.signupPassword} minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </label>
        <button data-testid={TID.signupSubmit} type="submit" disabled={busy}
          className="w-full py-3 rounded-2xl neu-fill-blue text-white font-semibold shadow-lg shadow-blue-900/30 active:scale-[0.98] transition-all disabled:opacity-60">
          {busy ? "…" : t("getStarted")}
        </button>
        <p className="text-sm text-slate-500 text-center">{t("haveAccount")} <Link className="neu-accent-blue font-semibold hover:underline" to="/login">{t("login")}</Link></p>
      </form>
    </div>
  );
}
